import { Link } from "./../../util/router";
import { apiRequest } from "../../util/util";

// Helper functions
function getAnswerTotal(questions) {
  return questions.reduce((total, q) => {
    const value = q.answer;
    return typeof value === 'number' ? total + value : total;
  }, 0);
};

function getEmailHTMLFromTier(top, middle, actual) {
  if (actual >= top) {
    // Top shows the Powerhouse Professionals email
    return `
      <html>
        <head>
          <meta charset="UTF-8" />
          <title>Survey Results</title>
        </head>
        <body style="font-family: Arial, sans-serif; background-color: #f7f7f7; margin: 0; padding: 20px;">
          <table width="100%" cellpadding="0" cellspacing="0" border="0">
            <tr>
              <td align="center">
                <table width="600" cellpadding="20" cellspacing="0" border="0" style="background-color: #ffffff; border-radius: 8px;">
                  <tr>
                    <td>
                      <h2 style="color: #2d3748;">Hi there,</h2>
                      <p style="font-size: 16px; color: #2d3748;">We've received your submission.<br><strong>You got <span style="color: #38a169;">Powerhouse Professional!</span></strong></p>

                      <h3 style="color: #2d3748;">The A-Team Agency</h3>
                      <p style="font-size: 16px; color: #2d3748;">
                        An A-Team Agency excels in key areas such as client satisfaction, operational efficiency, and agency results.
                      </p>

                      <h4 style="color: #2d3748;">Here are some things we could work on together to scale and grow your agency:</h4>

                      <ul style="font-size: 16px; color: #2d3748;">
                        <li>
                          <strong>Skill Development:</strong> The agency invests in skill development, but there may be challenges in keeping up with industry changes, tools and technology. The focus is on maintaining a competitive edge through continuous learning.
                        </li>
                        <li>
                          <strong>Innovation:</strong> The agency leads in innovation, but the pressure to stay ahead may cause stress.
                        </li>
                        <li>
                          <strong>Agency Culture:</strong> The team works well together, and there is a strong culture of support. The challenge is integrating new team members who will fit into this same culture. The team is energized and motivated, but the challenge is to keep this energy sustained, especially during high-pressure periods or growth phases.
                        </li>
                        <li>
                          <strong>Efficiency:</strong> The agency is highly efficient, but the challenge is to avoid over-optimization.
                        </li>
                      </ul>

                      <p style="font-size: 16px; color: #2d3748;">
                        You have done the hard work to lay a great foundation. We feel certain that we can partner with you to scale to the next level.
                      </p>

                      <h3 style="color: #2d3748;">Our Recommendation: <span style="color: #3182ce;">The Million Dollar Road Map</span></h3>

                      <p style="font-size: 16px; color: #2d3748;">
                        The Million Dollar Road Map is the ultimate growth package for agency owners who are serious about scaling their business. This comprehensive package includes <strong>Stairs & Buckets training, sales processes, and management tools</strong>, offering you and your team a complete toolkit to boost sales, enhance client relationships, and build a high-performing agency.
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        It includes:
                        <ul style="font-size: 16px; color: #2d3748;">
                          <li>Million Dollar Manual with proven strategies</li>
                          <li>Comprehensive Staff Handbook</li>
                          <li>All Sales Processes and Training Webinars</li>
                          <li>Non-Compete Agreement Templates</li>
                        </ul>
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">✅ <strong>Get Access To Our Complete Training Package</strong></p>

                      <p style="text-align: center;">
                        <a href="https://www.insuranceagencytraining.org/packages/tp" style="display: inline-block; padding: 12px 24px; background-color: #38a169; color: #ffffff; text-decoration: none; border-radius: 6px; font-weight: bold;">
                          Get Started - Click Here
                        </a>
                      </p>

                      <p style="text-align: center; margin-top: 20px;">
                        <a href="https://calendar.app.google/ZioDS5d5aEArQ9d56" style="display: inline-block; padding: 12px 24px; background-color: #38a169; color: #ffffff; text-decoration: none; border-radius: 6px; font-weight: bold;">
                          Book a Strategy Call
                        </a>
                      </p>

                      <p style="font-size: 16px; color: #2d3748; margin-top: 40px;">Thank you for participating,</p>
                      <p style="font-size: 16px; color: #2d3748;"><strong>Insurance Agency Training</strong><br><a href="https://www.insuranceagencytraining.org" style="color: #3182ce;">https://www.insuranceagencytraining.org</a></p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </body>
      </html>
    `
  } else if (actual >= middle) {
    // Middle shows the Savvy Advisors email
    return `
      <html>
        <head>
          <meta charset="UTF-8" />
          <title>Survey Results - Savvy Advisor</title>
        </head>
        <body style="font-family: Arial, sans-serif; background-color: #f7f7f7; margin: 0; padding: 20px;">
          <table width="100%" cellpadding="0" cellspacing="0" border="0">
            <tr>
              <td align="center">
                <table width="600" cellpadding="20" cellspacing="0" border="0" style="background-color: #ffffff; border-radius: 8px;">
                  <tr>
                    <td>
                      <h2 style="color: #2d3748;">Hi there,</h2>
                      <p style="font-size: 16px; color: #2d3748;">
                        We've received your submission.<br>
                        <strong>You Got <span style="color: #2b6cb0;">Savvy Advisor!</span></strong>
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        Steady Eddie agencies perform adequately, with solid client relationships.
                      </p>
                      <p style="font-size: 16px; color: #2d3748;">
                        There is progress, but gaps remain in areas like efficiency, training, and team culture.
                      </p>

                      <h4 style="color: #2d3748;">Here are some things we could work on together:</h4>

                      <ul style="font-size: 16px; color: #2d3748;">
                        <li><strong>Skill Development:</strong> The agency may not be fully embracing skill development. Gaps in training are evident and need attention.</li>
                        <li><strong>Innovation:</strong> Innovation happens sporadically. While the agency adapts to change, it often lags behind competitors in adopting new methods, tools and technologies.</li>
                        <li><strong>Agency Culture:</strong> Teamwork is generally good, but communication may be inconsistent. Collaboration happens, but there's room for improvement in creating a cohesive team. Team morale is positive, but there are fluctuations. Some employees feel supported, but others feel disengaged.</li>
                        <li><strong>Efficiency:</strong> Tasks are completed, but inefficiencies still exist. Processes could be improved and streamlined.</li>
                      </ul>

                      <h4 style="color: #2d3748;">Focus for Improvement:</h4>
                      <p style="font-size: 16px; color: #2d3748;">
                        Focus on innovation by investing in new tools to drive improvement and build a powerhouse agency.
                      </p>

                      <h3 style="color: #2d3748;">Our Recommendation: <span style="color: #38a169;">The Six Additional Sales Processes</span></h3>

                      <p style="font-size: 16px; color: #2d3748;">
                        For agency owners aiming to scale to a million dollars and beyond in sales, the <strong>6 Sales Processes</strong> are essential Life, Health, and Wealth solutions designed to elevate your sales.
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        This program simplifies sales processes, enabling your team to communicate Life, Health, and Wealth strategies, and drive greater profits for the agency.
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        Whether it's Medicare supplements, long-term care solutions, high-premium life insurance cases, or annuity sales—each process within the toolkit is crafted for you to sell at elite levels.
                      </p>

                      <h4 style="color: #2d3748;">Here's How the 6 Sales Processes Empowers Your Agency:</h4>

                      <ul style="font-size: 16px; color: #2d3748;">
                        <li><strong>Boosts Team Confidence and Sales:</strong> With clear, actionable sales steps, your team gains the confidence they need to engage clients, resulting in growth. For example, teams implementing the Medicare 101 have seen a 70% increase in sales as they simplify options for clients.</li>
                        <li><strong>Educates Clients for Better Outcomes:</strong> By educating clients through processes like <em>Finding the Money</em> and <em>Understanding Money: What Banks Don't Want You to Know</em>, your agency is viewed as financial experts that help people protect and grow their wealth.</li>
                      </ul>

                      <p style="font-size: 16px; color: #2d3748;">
                        If you're ready to expand your agency's impact, train your team on proven processes, and build a thriving business with million-dollar potential, the 6 Additional Sales Processes is your step-by-step guide to achieving that success.
                      </p>

                      <p style="text-align: center; margin: 30px 0;">
                        <a href="https://www.insuranceagencytraining.org/packages/tp" style="display: inline-block; padding: 12px 24px; background-color: #38a169; color: #ffffff; text-decoration: none; border-radius: 6px; font-weight: bold;">
                          Sign Up for the 6 Additional Sales Processes
                        </a>
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        Book a strategy call to see how we can help you make more money and have less stress.
                      </p>

                      <p style="text-align: center;">
                        <a href="https://calendar.app.google/ZioDS5d5aEArQ9d56" style="display: inline-block; padding: 12px 24px; background-color: #38a169; color: #ffffff; text-decoration: none; border-radius: 6px; font-weight: bold;">
                          Book a Strategy Call Here
                        </a>
                      </p>

                      <p style="font-size: 16px; color: #2d3748; margin-top: 40px;">Thank you for participating,</p>
                      <p style="font-size: 16px; color: #2d3748;">
                        <strong>Insurance Agency Training</strong><br />
                        <a href="https://www.insuranceagencytraining.org" style="color: #3182ce;">https://www.insuranceagencytraining.org</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </body>
      </html>
    `
  } else {
    // Bottom shows the Emerging Talent email
    return `
      <html>
        <head>
          <meta charset="UTF-8" />
          <title>Survey Results - Emerging Talent</title>
        </head>
        <body style="font-family: Arial, sans-serif; background-color: #f7f7f7; margin: 0; padding: 20px;">
          <table width="100%" cellpadding="0" cellspacing="0" border="0">
            <tr>
              <td align="center">
                <table width="600" cellpadding="20" cellspacing="0" border="0" style="background-color: #ffffff; border-radius: 8px;">
                  <tr>
                    <td>
                      <h2 style="color: #2d3748;">Hi there,</h2>
                      <p style="font-size: 16px; color: #2d3748;">
                        We've received your submission.<br>
                        <strong>You Got <span style="color: #d69e2e;">Emerging Talent!</span></strong>
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        Emerging Talent are in the early stages of building client relationships, operational processes, and team dynamics.
                      </p>

                      <h4 style="color: #2d3748;">Here are some things we could work on together:</h4>

                      <ul style="font-size: 16px; color: #2d3748;">
                        <li><strong>Skill Development:</strong> Minimal investment in training and professional development leads to stagnant skills and outdated methods. Employees may feel stuck and unmotivated to grow.</li>
                        <li><strong>Agency Culture:</strong> Teamwork is minimal, with poor communication. Team members often feel unsupported, and collaboration is rare. Team morale is low, and there's a lack of enthusiasm. Employees feel disengaged, which negatively impacts the overall work environment.</li>
                        <li><strong>Efficiency:</strong> Processes are inefficient, with frequent errors and delays. The agency may struggle to complete tasks on time, resulting in dissatisfaction internally and externally.</li>
                      </ul>

                      <h4 style="color: #2d3748;">Focus for Improvement:</h4>
                      <p style="font-size: 16px; color: #2d3748;">
                        Build and add new sales processes and use tools that lead to greater productivity.
                      </p>

                      <h3 style="color: #2d3748;">Our Recommendation: <span style="color: #3182ce;">The Stairs and Buckets Basic Package</span></h3>

                      <p style="font-size: 16px; color: #2d3748;">
                        Based on your Million Dollar Breakthrough Assessment results, our top recommendation is to begin with our introductory tool, <strong>Stairs and Buckets</strong>. This simple yet powerful product has helped agents add a minimum of <strong>$100k</strong> to their profits.
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        <strong>Why Stairs and Buckets?</strong><br />
                        Stairs and Buckets isn't just about boosting sales—it's about transforming your approach and empowering your team with new tools.
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        ✅ Save time and make $100,000 or more using Stairs and Buckets.
                      </p>

                      <p style="text-align: center; margin: 30px 0;">
                        <a href="https://www.insuranceagencytraining.org/packages/sb" style="display: inline-block; padding: 12px 24px; background-color: #38a169; color: #ffffff; text-decoration: none; border-radius: 6px; font-weight: bold;">
                          Sign Up for Stairs and Buckets Here
                        </a>
                      </p>

                      <p style="font-size: 16px; color: #2d3748;">
                        Book a strategy call to see how we can help you make more money and have less stress.
                      </p>

                      <p style="text-align: center;">
                        <a href="https://calendar.app.google/ZioDS5d5aEArQ9d56" style="display: inline-block; padding: 12px 24px; background-color: #38a169; color: #ffffff; text-decoration: none; border-radius: 6px; font-weight: bold;">
                          Book a Strategy Call Here
                        </a>
                      </p>

                      <p style="font-size: 16px; color: #2d3748; margin-top: 40px;">Thank you for participating,</p>
                      <p style="font-size: 16px; color: #2d3748;">
                        <strong>Insurance Agency Training</strong><br />
                        <a href="https://www.insuranceagencytraining.org" style="color: #3182ce;">https://www.insuranceagencytraining.org</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </body>
      </html>
    `
  }
}


export const surveyData = {
  longSurvey: {
    questions: [
      {
        question:
          "My team helps customers feel at ease and connects with them personally at the start of life insurance appointments.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team introduces the purpose of the discussion in a clear, concise manner.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team explains life insurance policies in a way that clients can easily understand.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team uses visual aids, videos, and stories to help explain life insurance.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team is confident in showing the customer options that illustrate what the customer wants.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team can explain what a short term policy is using stairs as an analogy.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team is comfortable explaining the problem that will come from future increases in short term policies.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team is able to establish a sense of urgency in appointments that motivates customers to take action immediately on their short term policies.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team is able to explain the additional benefits that come from converting to a long term policy.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team successfully communicates the long-term benefits of cash accumulation and savings inside permanent life insurance.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team encourages clients to consider additional coverage for themselves or family members when a need is identified.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team regularly asks if clients have similar coverage for their spouse or children and illustrates its importance.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team is confident at walking the customer through the process of a new application and underwriting for additional coverage.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team explains potential underwriting outcomes and helps clients make an informed decision.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team answers client questions confidently without becoming defensive or evasive.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team actively listens to client concerns and asks additional questions in order to address them.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team addresses misconceptions with simple explanations.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team asks clients confidently if they would like to move forward with a new policy or additional coverage.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team ensures clients understand the next steps and what is required of them.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team establishes the value of annual appointments when it comes to life insurance and schedules next year's appointment before the client leaves.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team is comfortable having life insurance appointments over the phone or virtually.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team has a strong life insurance sales script that is used consistently.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team consistently produces the majority of life insurance sales applications in the agency.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team sells the majority of large premium life insurance cases in the agency.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team and I follow a successful lead sales process when working life insurance leads from vendors.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team and I consistently purchase life insurance leads from lead vendors to supplement and enhance our life insurance sales.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
      {
        question:
          "My team asks for referrals from clients after every interaction.",
        options: [
          { text: "My Team is Great at This", value: 3 },
          { text: "My Team is Okay at This", value: 2 },
          { text: "My Team is Not Good at This", value: 1 },
        ],
      },
    ],
    endingFunc: async (questionsAndAnswers, email) => {
      // set off the email
      const total = getAnswerTotal(questionsAndAnswers)
      const topTierScore = 65
      const middleTierScore = 50
      let message = getEmailHTMLFromTier(topTierScore, middleTierScore, total)
      try {
        const data = {
          message: message,
          email: email,
          method: "Email",
          subject: "Survey Submission Results",
          category: "info",
        };
        const response = await apiRequest("send-message", "POST", data);
        console.log("Response after sending code:", response);
      } catch (error) {
        console.error("Error creating code: ", error)
      }
      return (
        <div className="max-w-xl mx-auto p-6 text-center">
          <h2 className="text-2xl font-bold">Survey Complete</h2>
          <p className="text-lg mt-4 mb-4">Thank you for completing the survey. An email summary will be sent to you.</p>
          <Link
            to="/dashboard/dashboard"
          >
            <button className="w-full px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition">Return to Dashboard</button>
          </Link>
        </div>
      )
    }
  },
  shortSurvey: {
    questions: [
      {
        category: "Client Engagement",
        question: "How well does your team connect with clients and explain life insurance clearly?",
        options: [
          { text: "Excellent", value: 3 },
          { text: "Adequate", value: 2 },
          { text: "Needs Improvement", value: 1 },
        ],
      },
      {
        category: "Sales Process Execution",
        question: "How consistently does your team use scripts, explain policy options, and move clients to action?",
        options: [
          { text: "Excellent", value: 3 },
          { text: "Adequate", value: 2 },
          { text: "Needs Improvement", value: 1 },
        ],
      },
      {
        category: "Policy Structuring",
        question: "How confident is your team in presenting and positioning short- vs long-term policy benefits?",
        options: [
          { text: "Excellent", value: 3 },
          { text: "Adequate", value: 2 },
          { text: "Needs Improvement", value: 1 },
        ],
      },
      {
        category: "Cross-Selling and Referrals",
        question: "How often does your team identify additional needs and ask for referrals?",
        options: [
          { text: "Always", value: 3 },
          { text: "Sometimes", value: 2 },
          { text: "Rarely", value: 1 },
        ],
      },
      {
        category: "Lead Conversion",
        question: "How effective is your team with lead vendors and closing new applications?",
        options: [
          { text: "High Conversion", value: 3 },
          { text: "Moderate Conversion", value: 2 },
          { text: "Low Conversion", value: 1 },
        ],
      },
      {
        category: "Role",
        question: "Your role in the agency?",
        options: [
          { text: "Agent/Owner/Broker", value: "Agent/Owner/Broker" },
          { text: "Team Member/Agent", value: "Team Member/Agent" },
        ],
      },
    ],
    endingFunc: async (questionsAndAnswers, email) => {
      // set off the email
      const total = getAnswerTotal(questionsAndAnswers)
      const topTierScore = 12
      const middleTierScore = 9
      let message = getEmailHTMLFromTier(topTierScore, middleTierScore, total)
      try {
        const data = {
          message: message,
          email: email,
          method: "Email",
          subject: "Survey Submission Results",
          category: "info",
        };
        const response = await apiRequest("send-message", "POST", data);
        console.log("Response after sending survey email:", response);
      } catch (error) {
        console.error("Error creating survey email: ", error)
      }
      return (
        <div className="max-w-xl mx-auto p-6 text-center">
          <h2 className="text-2xl font-bold">Survey Complete</h2>
          <p className="text-lg mt-4 mb-4">Thank you for completing the survey. An email summary will be sent to you.</p>
          <Link
            to="/dashboard/dashboard"
          >
            <button className="w-full px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition">Return to Dashboard</button>
          </Link>
        </div>
      )
    }
  },
}
